"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkHandler = void 0;
var meta_1 = require("./meta");
var client_path_1 = require("./client-path");
var LinkHandler = /** @class */ (function () {
    function LinkHandler() {
    }
    LinkHandler.setup = function () {
        var _this = this;
        // Target _blank is ignored in order to handle shop links (facebook and website)
        $('a:not(.to-campaign):not(.to-inspiration):not([target="_blank"])').click(function (event) {
            if (event.ctrlKey || event.metaKey) {
                event.preventDefault();
                var clientPath = client_path_1.ClientPath.fromClickEvent(event);
                _this.openClientPathInNewTabOnCurrentPath(clientPath);
            }
        });
        $('a.to-campaign').click(function (event) {
            _this.handleWidgetClicks(event, meta_1.Meta.campaignPath);
        });
        $('a.to-inspiration').click(function (event) {
            _this.handleWidgetClicks(event, meta_1.Meta.inspirationPath);
        });
    };
    /**
     * @param event (the click event)
     * @param path (eg. "campaigns.php" or "inspiration.php")
     */
    LinkHandler.handleWidgetClicks = function (event, path) {
        event.preventDefault();
        // Open on new tab (_blank) or on the mall website (_parent of the iframe)
        var target = event.ctrlKey || event.metaKey ? '_blank' : '_parent';
        var clientPath = client_path_1.ClientPath.fromClickEvent(event);
        var url = meta_1.Meta.host + '/' + path + clientPath;
        window.open(url, target);
    };
    /**
     * Will open the given client path on the current location (to open links on campaigns.php or inspiration.php)
     * @param clientPath (eg. "#all?page=2" or "?mw=all&page=2")
     */
    LinkHandler.openClientPathInNewTabOnCurrentPath = function (clientPath) {
        // Split the client URL at # if we are using hash, or ? if we are using get parameters
        var splitSeparator = meta_1.Meta.useHash ? '#' : '?';
        var baseURL = meta_1.Meta.clientURL.split(splitSeparator)[0];
        window.open(baseURL + clientPath, '_blank');
    };
    return LinkHandler;
}());
exports.LinkHandler = LinkHandler;
